import { render } from "./CalendarPage.vue?vue&type=template&id=3dffdca0&scoped=true&ts=true"
import script from "./CalendarPage.vue?vue&type=script&lang=ts"
export * from "./CalendarPage.vue?vue&type=script&lang=ts"

import "./CalendarPage.vue?vue&type=style&index=0&id=3dffdca0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dffdca0"]])

export default __exports__